import Filter from 'bad-words';

const filter = new Filter();

export const isProfane = (text) => {
  if (!text) return false;
  try {
    return filter.isProfane(text);
  } catch (_) {
    return false;
  }
};

export const cleanText = (text) => {
  if (!text) return text;
  try {
    return filter.clean(text);
  } catch (_) {
    return text;
  }
};

